module.exports = __webpack_public_path__ + "static/media/gateway-spring-cloud.ef454b2d.png";